import { useRouteError } from "react-router";
import resolveError from "../../common/utils/error-resolver";


/**
 * Renders router-level errors by mapping them to friendly messages.
 * @returns Simple error display leveraging the shared resolver.
 */
export function ErrorElement() {
    let error = useRouteError();
    console.error(error);
    // Uncaught ReferenceError: path is not defined
    return <div>{resolveError(error)}</div>;
  }